import { Component, EventEmitter, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingService, AlertService } from 'ngx-kuv-tools';
import { ConfigService } from 'src/app/utils/config/config.service';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { ModalDeleteComponent } from 'src/app/utils/modal-delete/modal-delete.component';
import { SesionService } from 'src/app/utils/sesion/sesion.service';
import { TipoRevisionService } from '../../tipo-revision/tipo-revision.service';
import { VehiculoCreateComponent } from '../../vehiculo/vehiculo-create/vehiculo-create.component';
import { VehiculoUpdateComponent } from '../../vehiculo/vehiculo-update/vehiculo-update.component';
import { VehiculoViewComponent } from '../../vehiculo/vehiculo-view/vehiculo-view.component';
import { RevisionCreateComponent } from '../revision-create/revision-create.component';
import { RevisionUpdateComponent } from '../revision-update/revision-update.component';
import { RevisionViewComponent } from '../revision-view/revision-view.component';
import { RevisionService } from '../revision.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-revision-index',
  templateUrl: './revision-index.component.html',
  styleUrls: ['./revision-index.component.scss']
})
export class RevisionIndexComponent implements OnInit {

  url: string = '';
  excel: string = '';

  reloadEmitter: EventEmitter<string> = new EventEmitter();

  filtros = [
    {
      label: 'Desde',
      column: 'fecha',
      op: 'gte',
      type: 'date'
    },
    {
      label: 'Hasta',
      column: 'fecha',
      op: 'lte',
      type: 'date'
    },
    {
      label: 'Patente',
      column: '$Vehiculo.patente$',
      op: 'like',
    },
    {
      label: 'Tipo',
      column: 'tipo_revision_id',
      op: 'like',
      type: 'select',
      options: [
        {
          label: "Motor",
          value: '1'
        },
        {
          label: "Diferencial",
          value: '2'
        },
        {
          label: "Caja de Cambio",
          value: '3'
        },
      ],
    },
    {
      label: 'Kilometraje',
      column: 'kilometraje',
      op: 'like',
    },
    {
      label: 'Encargado',
      column: 'encargado',
      op: 'like',
    },
    {
      label: 'Estimada Desde',
      column: 'fecha_estimada',
      op: 'gte',
      type: 'date'
    },
    {
      label: 'Estimada Hasta',
      column: 'fecha_estimada',
      op: 'lte',
      type: 'date'
    },
  ]

  acciones = [
    {
      label: 'Ver',
      icon: 'eye',
      action: (element: any, index: number) => {
        this.view(element)
      }
    },
    {
      label: 'Editar',
      icon: 'pen',
      action: (element: any, index: number) => {
        this.edit(element)
      }
    },
    {
      label: 'Descargar',
      icon: 'file-pdf',
      action: (element: any, index: number) => {
        this.descargar(element)
      }
    },
    {
      icon: "trash",
      label: "Eliminar",
      action: (element: any, index: number) => {
        this.delete(element);
      },
      hide: (element: any, index: number) => {
      }
    }
  ]

  columnas = [
    {
      label: 'Fecha',
      attribute: 'fecha',
      width: 1,
      responsive: ['SM'],
      value: (element: any, index: number) => {
        return this.formatter.dateFormat(element.fecha);
      }
    },
    {
      label: 'Patente',
      attribute: 'patente',
      width: 1,
      responsive: ['XS', 'SM', 'MD'],
      value: (element: any, index: number) => {
        return element.vehiculo.patente;
      }
    },
    {
      label: 'Cliente',
      attribute: 'cliente',
      width: 1,
      responsive: ['XS', 'SM', 'MD'],
      value: (element: any, index: number) => {
        if (!element.vehiculo?.usuario) return 'Sin dueño'
        return this.formatter.nombreCompleto(element.vehiculo?.usuario);
      }
    },
    {
      label: 'Tipo Servicio',
      attribute: '$tipo_revision.tipo$',
      width: 1,
      responsive: ['SM', 'MD'],
      value: (element: any, index: number) => {
        if (element.tipo_revision) return element.tipo_revision.nombre;
        else return '-';
      }
    },
    {
      label: 'Fecha Estimada',
      attribute: 'fecha_estimada',
      width: 1,
      responsive: ['SM'],
      value: (element: any, index: number) => {
        return this.formatter.dateFormat(element.fecha_estimada);
      }
    },
  ]

  constructor(
    private config: ConfigService,
    private modalService: NgbModal,
    public loading: LoadingService,
    private alerts: AlertService,
    public service: RevisionService,
    public sesion: SesionService,
    public formatter: FormatterService,
    private router: Router,
    private tipoService: TipoRevisionService
  ) { }

  ngOnInit(): void {
    this.url = this.config.apiUrl + this.service.controller + 'ver';
    this.excel = this.config.apiUrl + this.service.controller + 'excel';
    this.loadTipos();
  }

  loadTipos() {
    this.loading.show()
    this.tipoService.index().subscribe({
      next: (res) => {
        this.loading.hide();
        this.filtros[3].options = res.map((e: any) => {
          return {
            value: e.id,
            label: e.nombre
          }
        });
      },
      error: err => {
        console.error(err);
        this.loading.hide();
        if (err.error) this.formatter.showErrorAlerts(err.error);
      }
    });
  }

  add(): void {
    this.router.navigate(['revisiones/create'])
    // const modalRef = this.modalService.open(RevisionCreateComponent, { windowClass: 'clear-modal', size: 'xl', scrollable: true, backdrop: 'static' });
    // modalRef.result.then((result: any) => {
    //   this.loadData();
    // }, (reason: any) => { });
  }

  view(element: any): void {
    const modalRef = this.modalService.open(RevisionViewComponent, { windowClass: 'clear-modal', size: 'xl', scrollable: true });
    modalRef.componentInstance.element = element;
    modalRef.result.then((result: any) => {
      this.loadData();
    }, (reason: any) => { });
  }

  edit(element: any): void {
    const modalRef = this.modalService.open(RevisionUpdateComponent, { windowClass: 'clear-modal', size: 'xl', scrollable: true, backdrop: 'static' });
    modalRef.componentInstance.element = element;
    modalRef.result.then((result: any) => {
      this.loadData();
    }, (reason: any) => { });
  }

  descargar(element: any){
    this.loading.show();
    this.service.downloadPdf(element).subscribe({ next: (res: any) => {
      this.loading.hide();
      let downloadURL = window.URL.createObjectURL(res);
      let link = document.createElement('a');
      link.href = downloadURL;
      link.download = `Orden de Trabajo N°${element.id}.pdf`;
      link.click();
    }, error: (err: any) => {
      this.loading.hide();
      this.alerts.addAlert('No se pudo descargar el documento.', 'danger');
    }});
  }

  toggle(element: any): void {
    if (element.estado == 0) {
      this.loading.show();
      this.service.activate(element.id).subscribe({
        next: (res: any) => {
          this.loading.hide();
          this.loadData();
          this.alerts.addAlert("Revisión activada con éxito.", "danger");
        },
        error: (err: any) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se ha podido activar el registro.", "danger");
        }
      });
      return;
    }
    if (element.estado == 1) {
      this.loading.show();
      this.service.deactivate(element.id).subscribe({
        next: (res: any) => {
          this.loading.hide();
          this.loadData();
          this.alerts.addAlert("Revisión desactivada con éxito.", "danger");
        },
        error: (err: any) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se ha podido desactivar el registro.", "danger");
        }
      });
    }
  }

  delete(element: any): void {
    const modalRef = this.modalService.open(ModalDeleteComponent, { windowClass: 'clear-modal', size: 'md', scrollable: true, backdrop: 'static' });
    modalRef.componentInstance.titulo = 'Eliminar Revisión';
    modalRef.componentInstance.texto = '¿Seguro que desea eliminar este registro?';
    modalRef.componentInstance.textoAceptar = 'Eliminar';
    modalRef.result.then((result) => {
      this.loading.show();
      this.service.delete(element.id).subscribe({
        next: (res: any) => {
          this.loading.hide();
          this.loadData();
          this.alerts.addAlert("Revisión de servicio eliminado con éxito.", "success");
        },
        error: (err: any) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se ha podido eliminar el registro de revisión.", "danger");
        }
      });
    }, (reason) => { });
  }

  loadData(): void {
    this.reloadEmitter.emit();
  }
}
